import React from 'react';
import { Link } from 'react-router-dom';
import { ExportToPDFButton } from '../../common/ExportToPDFButton/ExportToPDFButton';

const PlanMetrics = props => {
  if (!props.organization) {
    return null;
  }

  let org = props.organization;

  const circle = <i className="fa fa-circle-thin" />;
  const check = <i className="fa fa-check-circle" />;
  const checkinKeys = ['1', '2', '3'];

  let corePlanned = 0;
  let electivePlanned = 0;
  let componentsWithinTarget = 0;

  checkinKeys.forEach(key => {
    corePlanned += org.core[key].planned;
    electivePlanned += org.elective[key].planned;
    if (org.components[key].criticality === 'good') {
      componentsWithinTarget++;
    }
  }, electivePlanned);

  let coreCheck = circle;
  if (corePlanned >= 40) {
    coreCheck = check;
  }

  let electiveCheck = circle;
  if (org.electiveCredits >= 25) {
    electiveCheck = check;
  }

  let componentCheck = circle;
  if (componentsWithinTarget === 3) {
    componentCheck = check;
  }

  let electiveConceptCount = 0;
  if (org.elective_concept_count) {
    electiveConceptCount = org.elective_concept_count;
  }
  let electiveConceptsCheck = circle;
  if (electiveConceptCount >= 5) {
    electiveConceptsCheck = check;
  }

  return (
    <div className="PlanMetrics">
      <div className="ProjectPlan">
        <p className="header">Project Plan</p>
        <ul>
          <li>
            {coreCheck}
            {Math.ceil(corePlanned)} Core Criteria
          </li>
          <li>
            {electiveCheck}
            {Math.ceil(org.electiveCredits)} Elective Credits
          </li>
          <li>
            {componentCheck}
            {componentsWithinTarget}/3 Components/Check-in Target
          </li>
          <li>
            {electiveConceptsCheck}
            {electiveConceptCount} / 5 Concepts with Electives
          </li>
        </ul>
      </div>
      <div className="Legend">
        <p className="LegendHeader">Legend</p>
        <ul className="LegendItems">
          <li>
            <div className="LegendItems__key LegendItems__good" /> Good
          </li>
          <li>
            <div className="LegendItems__key LegendItems__warn" /> Warning
          </li>
          <li>
            <div className="LegendItems__key LegendItems__critical" /> Critical
          </li>
          <li>
            <div className="LegendItems__key LegendItems__qready" />
            <div className="LegendItems__key LegendItems__qsubmit" />
            <div className="LegendItems__key LegendItems__met" />
            <div className="LegendItems__key LegendItems__prevalidated" />
            Complete
          </li>
          <li>
            <Link to="/help/legend">
              <i className="fa fa-question-circle-o" /> Thresholds
            </Link>
          </li>
        </ul>
        </div>
        <div className="PlanMetrics__Export">
        <ExportToPDFButton organizationName={org.name}/>
        </div>
    </div>
  );
};

export default PlanMetrics;

/*
<li>
    {check}
    6/5 Concepts with Electives
</li>
 */
